import { isSuccess } from '@/context/services/type';
import { isCommonError } from '@/libs/typeguard/isError';

import {
  type ApMismatchAlertSetting,
  useGetApMismatchAlertSettings,
} from 'ap-openapi';

type FetchApMismatchAlertSetting = {
  data?: ApMismatchAlertSetting[];
  error?: {
    messages?: string[];
    code?: string;
  };
};

export const useApMismatchAlertSettings = (
  enabled: boolean
): FetchApMismatchAlertSetting => {
  const { data, error } = useGetApMismatchAlertSettings({
    query: { enabled },
  });

  if (error) throw error;

  const body = data?.data;
  const status = data?.status;
  const isSuccessStatus = isSuccess(status);

  if (!isSuccessStatus) {
    return {
      error: {
        messages:
          typeof body === 'object' && isCommonError(body)
            ? body.messages
            : undefined,
        code: status?.toString(),
      },
    };
  }
  return {
    data: body?.ap_mismatch_alert_settings,
  };
};
